import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Button, Collapse, Typography, InputAdornment, CircularProgress, Pagination, Dialog, DialogTitle, Select, DialogContent, MenuItem, DialogActions } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp, Print, FilterList, Search, ExpandMore } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import FedExLogo from '@/assets/FedEx.svg';
import PartialIcon from '@/assets/partial.svg';
import DeliveredIcon from '@/assets/delivered.svg';
import DelayedIcon from '@/assets/delayed.svg';
import * as S from './styles';
import { useDataApi } from "@/hooks";
import { baseUrl } from "@/consts";
import { AllOrderType, OrderApiResponse, OrderTrackApiResponse, TrackingRecord } from "./interface";
import axios from "axios";
import { AlertDialog } from "@/components/organisms";
import { formatAxiosError } from "@/utils";
import { filters } from "./constants";
import { useZebraPrinter } from "./useZebraPrinter";


const statusIcon = (type: string) => {
  switch (type) {
    case "Delivered":
      return <img src={DeliveredIcon} alt="Delivered" style={{ width: 40, height: 40, marginRight: 8 }} />;
    case "Delayed":
      return <img src={DelayedIcon} alt="Delayed" style={{ width: 40, height: 40, marginRight: 8 }} />;
    case "Partial":
      return <img src={PartialIcon} alt="Partial" style={{ width: 40, height: 40, marginRight: 8 }} />;
    default:
      return <img src={PartialIcon} alt="Unknown" style={{ width: 40, height: 40, marginRight: 8, opacity: 0.5 }} />;
  }
};


function ShippingPortalTableRow({ row }: { row: AllOrderType }) {
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false)
  const hasMultipleBoxes = (row.trackingDetails?.filter(item => item.trackingNumber).length || 0) > 1
  const orderStatus = row.trackingDetails?.find(item => !!item.deliveryStatus)?.deliveryStatus || "Unknown";
  const getTrackingIcon = (status?: string) => status == "Delivered" ? DeliveredIcon : status == "Delayed" ? DelayedIcon : PartialIcon

  // custom hooks
  const { _get, response, isLoading } = useDataApi()
  const { devices, onDeviceSelected, selectedDevice, sendZpl } = useZebraPrinter()

  useEffect(() => {
    if (response?.data)
      setOpenDialog(true);
  }, [response])

  const handlePrint = () => {
    if (response?.data) {
      const labels = Array.isArray(response?.data) ? response?.data.map(item => item.labelData) : [response?.data.labelData]
      console.log("Sending labels for print")
      labels.forEach((label) => {
        const decodedLabel = atob(label);
        sendZpl(decodedLabel);
      }
      )
      setOpenDialog(false)
    }
    else {
      alert("labels not avaible, please try again!")
      setOpenDialog(false)
    }
  }


  return (
    <>
      <S.StyledTableRow>
        <S.TableCellBold>
          <Box display="flex" alignItems="center">
            {statusIcon(orderStatus)}
            <span style={{ fontWeight: 700, marginTop: 6 }}>{orderStatus}</span>
          </Box>
        </S.TableCellBold>
        <S.TableCellNormal>{(row.firstName ?? "") + " " + (row.lastName ?? "")}</S.TableCellNormal>
        <S.TableCellNormal>{row.company}</S.TableCellNormal>
        <S.TableCellNormal>{row.shippingCity}, {row.shippingState}</S.TableCellNormal>
        <S.TableCellNormal>Order# {row.orderId}</S.TableCellNormal>
        <S.TableCellNormal>
          <Box display="flex" alignItems="center" justifyContent='center' gap={1}>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              {hasMultipleBoxes ? (
                <Box display="flex" alignItems='center' mt={0.5}>
                  <Typography fontWeight={700} fontSize={16} sx={{ fontFamily: 'PF DIN Text Pro', textAlign: 'center' }}>{row.numberOfBoxes} boxes</Typography>
                  <IconButton size="small" sx={{ ml: 0.5, p: 0 }} onClick={() => setOpen(!open)}>
                    <ExpandMore sx={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.3s' }} />
                  </IconButton>
                </Box>
              ) : (
                <Typography color="#337ace" fontWeight={700} fontSize={16} sx={{ fontFamily: 'PF DIN Text Pro', textAlign: 'center' }}>{row.trackingDetails?.find(item => item.trackingNumber)?.trackingNumber}</Typography>
              )}
            </Box>
          </Box>
        </S.TableCellNormal>
        <S.TableCellNormal>
          <S.PrintButton disabled={isLoading} onClick={() => _get(`${baseUrl.ORDER}/printorderboxes/${row.orderId}`)}>
            {isLoading ? <CircularProgress sx={{ mr: 1, color: "white" }} size={25} /> : <Print sx={{ mr: 1 }} />} Print Labels
          </S.PrintButton>
        </S.TableCellNormal>
      </S.StyledTableRow>
      {hasMultipleBoxes && open && (
        row.trackingDetails?.map((detail, i) => (
          <TableRow key={i} {...console.log(detail) as any}>
            <S.TableCellBold sx={{ p: 0, background: '#F7F8FA', border: 'none' }} />
            <S.TableCellNormal sx={{ background: '#F7F8FA', border: 'none' }} />
            <S.TableCellNormal sx={{ background: '#F7F8FA', border: 'none' }} />
            <S.TableCellNormal sx={{ background: '#F7F8FA', border: 'none', p: 0 }} colSpan={2}>
              <Box display="flex" alignItems="center" gap={2} minHeight={48} paddingLeft={12}>
                <img src={getTrackingIcon(detail.deliveryStatus)} alt={detail.deliveryStatus} style={{ width: 32, height: 32, marginBottom: 2 }} />
                <Box>
                  <Typography fontWeight={700} fontSize={16} sx={{ fontFamily: 'PF DIN Text Pro', textAlign: "left" }}>{detail.deliveryStatus}</Typography>
                  <Typography fontSize={15} color="#4E5D75" sx={{ fontFamily: 'PF DIN Text Pro', mt: '-2px' }}>{detail?.location}</Typography>
                </Box>
              </Box>
            </S.TableCellNormal>
            <S.TableCellNormal sx={{ background: '#F7F8FA', border: 'none', p: 0 }}>
              <Box display="flex" alignItems="center" justifyContent="center" minHeight={48}>
                <Typography color="#337ace" fontWeight={700} fontSize={16} sx={{ fontFamily: 'PF DIN Text Pro', textAlign: 'center' }}>{detail?.trackingNumber}</Typography>
              </Box>
            </S.TableCellNormal>
            <S.TableCellNormal sx={{ background: '#F7F8FA', border: 'none', p: 0 }}>
              <Box display="flex" alignItems="center" justifyContent="center" minHeight={48}>
                <S.PrintIconButton onClick={() => _get(`${baseUrl.ORDER}/printorderbox/${detail.orderBoxId}`)}><Print /></S.PrintIconButton>
              </Box>
            </S.TableCellNormal>
          </TableRow>
        ))
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Zebra Printer</DialogTitle>

        <DialogContent>
          {devices.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Searching for printers...
            </Typography>
          ) : (
            <>
              <Typography>Select Printer:</Typography>
              <Select
                fullWidth
                value={selectedDevice?.uid || ''}
                onChange={(e) => onDeviceSelected(e.target.value)}
              >
                {devices.map((device) => (
                  <MenuItem key={device.uid} value={device.uid}>
                    {device.name}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handlePrint} disabled={!selectedDevice}>
            Print Label
          </Button>
        </DialogActions>
      </Dialog>
    </>

  );
}

const ShippingPortal: React.FC = () => {
  const [allOrders, setAllOrders] = useState<AllOrderType[] | undefined>(undefined)
  const [filteredOrders, setFilteredOrders] = useState<AllOrderType[] | undefined>(undefined)
  const [searchValue, setSearchValue] = useState("")
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState("none")
  const [openFilter, setOpenFilter] = useState(false)
  // pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const timeRef = useRef<NodeJS.Timeout | null>(null)

  // local hook
  const { data, isLoading, setUrl, error } = useDataApi(`${baseUrl.ORDER}/withorderboxes?pageNum=1&pageSize=10&sortType=desc`);

  // derived values
  const apiResponse: OrderApiResponse = data

  // methods
  const getAllOrderTrackings = async () => {
    const allOrderIds = apiResponse?.data?.map(item => item.orderId).filter(order => order);
    if (allOrderIds) {
      try {
        setLoading(true)
        const allOrderApiPromises = allOrderIds.map(orderId => axios.get<OrderTrackApiResponse[]>(`${baseUrl.ORDER}/getorderboxes/${orderId}`))
        const result = await Promise.all(allOrderApiPromises)
        let requiredResponse = result.filter(item => item.status == 200).map(item => item.data)
        const afterInsert = apiResponse?.data?.map(order => ({ ...order, trackingDetails: requiredResponse.find(track => track.some(detail => detail.orderId == order.orderId)) }))

        // all tracking ids call:
        const allTrackingIds = requiredResponse.flatMap(item => item.map(track => track.trackingNumber)).filter(item => item)
        const allTrackingPromises = allTrackingIds.map(item => axios.get<TrackingRecord>(`${baseUrl.FedEx}/trackpackage?trackingNumber=${item}`))
        const allTrackingsResponse = await Promise.all(allTrackingPromises)
        const requiredTrackings = allTrackingsResponse.filter(item => item.status == 200).flatMap(item => item.data.trackingItems)
        const finalData = afterInsert?.map(data => {
          const trackingMatched = data.trackingDetails?.some(item => requiredTrackings.some(track => track.trackingNumber == item.trackingNumber))
          if (trackingMatched) {
            return {
              ...data,
              trackingDetails: data.trackingDetails?.map(detail => ({ ...detail, deliveryStatus: requiredTrackings.find(track => track.trackingNumber == detail.trackingNumber)?.status, location: requiredTrackings.find(track => track.trackingNumber == detail.trackingNumber)?.location }))
            }

          }
          else return data
        })
        setAllOrders(finalData)
      } catch (error) {
        console.log(error)
      }
      finally {
        setLoading(false)

      }
    }
  }

  // useEffects
  useEffect(() => {
    setUrl(`${baseUrl.ORDER}/withorderboxes?pageNum=${page}&pageSize=${pageSize}`);
    setFilter("none")
  }, [page, pageSize]);


  useEffect(() => {
    if (apiResponse?.data) getAllOrderTrackings();
    if (apiResponse?.totalPages) setTotalPages(apiResponse.totalPages)
    if (error) setLoading(false)
  }, [data, error])


  useEffect(()=>{
    if(timeRef.current) clearTimeout(timeRef.current)
      timeRef.current = setTimeout(() => {
        setUrl(`${baseUrl.ORDER}/withorderboxes?pageNum=1&pageSize=10&sortType=desc&search=${searchValue}`)
      }, 100);
  },[searchValue])

  useEffect(() => {
    if (searchValue || filter) setFilteredOrders(allOrders?.filter(order => [...order.trackingDetails!?.map(track => track.trackingNumber), ...order.trackingDetails!?.map(track => track.deliveryStatus), order.orderId, order.firstName, order.lastName, `${order.firstName} ${order.lastName}`, order.dealerIdentifier].map(String).some(state => {
      if (searchValue && filter !== "none") {
        return state.toLowerCase().includes(searchValue.toLocaleLowerCase()) && order.trackingDetails?.some(status => (status.deliveryStatus ?? "") == filter)
      }
      else if (searchValue) {
        return state.toLowerCase().includes(searchValue.toLocaleLowerCase())
      }
      else if (filter !== "none") {
        return state == filter
      }
      else return true
    })))
    else setFilteredOrders(undefined)
  }, [filter])


  const showLoading = isLoading || loading


  return (
    <S.PortalContainer>
      <S.Header>
        <S.FedExLogo src={FedExLogo} alt="FedEx" />
        <S.Title>Shipping Portal</S.Title>
      </S.Header>
      <S.Card>
        <S.SearchFilterRow>
          <S.SearchInputWrapper>
            <S.SearchInput
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
              placeholder="Search Tracking ID, Order #, Recipient Name or Badge ID"
              startAdornment={
                <InputAdornment position="start">
                  <Search sx={{ color: '#B8C2D2', fontSize: 22 }} />
                </InputAdornment>
              }
            />
          </S.SearchInputWrapper>
          <S.FilterWrapper>
            {openFilter && <S.FilterBox>
              {
                filters.map(data =>
                (<S.FilterIcon key={data.title} onClick={() => { setFilter(data.icon); setOpenFilter(false) }}>
                  {statusIcon(data.icon)}
                  <S.Text>{data.title}</S.Text>
                </S.FilterIcon>))
              }
            </S.FilterBox>}
            {/* <S.FilterButton endIcon={statusIcon(filter)} onClick={() => setOpenFilter(true)}>
              Filter by Status
            </S.FilterButton> */}
          </S.FilterWrapper>
        </S.SearchFilterRow>
        <TableContainer sx={{ mt: 3, borderRadius: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <S.TableCellBold header>Status</S.TableCellBold>
                <S.TableCellBold header>Recipient Name</S.TableCellBold>
                <S.TableCellBold header>Recipient Company</S.TableCellBold>
                <S.TableCellBold header>Recipient City Name</S.TableCellBold>
                <S.TableCellBold header>Order #</S.TableCellBold>
                <S.TableCellBold header>Tracking ID</S.TableCellBold>
                <S.TableCellBold header></S.TableCellBold>
              </TableRow>
            </TableHead>
            {!showLoading && <TableBody>
              {(filteredOrders ? filteredOrders : allOrders)?.map((row, idx) => (
                <ShippingPortalTableRow row={row} key={idx} />
              ))}
            </TableBody>}
          </Table>
        </TableContainer>
        {error ? (
          <AlertDialog
            message={formatAxiosError(error)}
            title="Error"
            confirmText="Ok"
            severity="error"
          />
        ) : null}
        {showLoading && <Box sx={{ display: "flex", justifyContent: "center", my: 10 }}><CircularProgress sx={{ position: "relative", top: -40 }} size={50} /></Box>}
        <Box display="flex" justifyContent="center" mt={3} pb={3}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </S.Card>
    </S.PortalContainer>
  );
};

export default ShippingPortal;
